import { apiFetch } from "@/lib/api";

export type ClampQcReQcLineInput = {
  size: "small" | "large";
  quantity: number;
};

export type ClampQcReQcResponse = {
  ok: true;
  workOrders: Array<{
    buildOrderId: number;
    workOrderNumber: string | null;
    sku: string;
    size: "small" | "large";
    quantity: number;
    slug: string;
  }>;
};

export function createClampQcReQcWorkOrders(input: {
  mfrReferenceNumber: string;
  notes?: string;
  lines: ClampQcReQcLineInput[];
}): Promise<ClampQcReQcResponse> {
  return apiFetch<ClampQcReQcResponse>("/api/clamp-qc/re-qc/work-orders", {
    method: "POST",
    body: JSON.stringify(input),
  });
}
